(function () {
	'use strict';

	async function addToCart(button) {
		if (button.disabled || button.classList.contains('is-loading')) return;
		if (!button.dataset.variantId) return;

		button.classList.add('is-loading');
		button.setAttribute('aria-busy', 'true');

		const formData = new FormData();
		formData.append('id', button.dataset.variantId);
		formData.append('quantity', 1);

		const cartDrawer = document.querySelector('cart-drawer');
		if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
			formData.append(
				'sections',
				cartDrawer.getSectionsToRender().map((section) => section.id)
			);
			formData.append('sections_url', window.location.pathname);
		}

		const addUrl =
			(window.FoxThemeSettings && window.FoxThemeSettings.routes && window.FoxThemeSettings.routes.cart_add_url) ||
			'/cart/add';

		try {
			const response = await fetch(addUrl, {
				method: 'POST',
				headers: {
					Accept: 'application/javascript',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: formData,
			});
			const result = await response.json();

			if (result.status) {
				console.error('[pdp-fbt] ajout panier refusé :', result.description);
				return;
			}

			if (window.FoxThemeEvents && typeof window.FoxThemeEvents.emit === 'function') {
				window.FoxThemeEvents.emit('ON_ITEM_ADDED', result);
			}
		} catch (error) {
			console.error('[pdp-fbt]', error);
		} finally {
			button.classList.remove('is-loading');
			button.removeAttribute('aria-busy');
		}
	}

	if (!window.__pdpFbtAtcBound) {
		window.__pdpFbtAtcBound = true;
		document.addEventListener('click', (event) => {
			const button = event.target.closest('[data-pdp-fbt-atc]');
			if (button) addToCart(button);
		});
	}

	if (!customElements.get('pdp-fbt')) {
		class PdpFbt extends HTMLElement {
			connectedCallback() {
				if (this.initialized) return;
				this.initialized = true;

				const observer = new IntersectionObserver(
					(entries, obs) => {
						if (!entries[0].isIntersecting) return;
						obs.disconnect();
						this.load();
					},
					{ rootMargin: '0px 0px 400px 0px' }
				);
				observer.observe(this);
			}

			async load() {
				try {
					const response = await fetch(this.dataset.url);
					if (!response.ok) throw new Error(`HTTP ${response.status}`);
					const text = await response.text();

					const parsed = document.createElement('div');
					parsed.innerHTML = text;
					const section = parsed.querySelector('pdp-fbt');
					const count = section
						? section.querySelectorAll('.pdp-cross-sell-inline__card').length
						: 0;

					if (!section || count === 0) {
						this.hidden = true;
						return;
					}

					const slot = this.querySelector('[data-pdp-fbt-slot]');
					(slot || this).innerHTML = section.innerHTML;
				} catch (error) {
					console.error('[pdp-fbt]', error);
					this.hidden = true;
				}
			}
		}

		customElements.define('pdp-fbt', PdpFbt);
	}
})();
